import styled from 'styled-components';

import { IllustrationExtMeditation } from '@xing-com/illustrations';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  spaceL,
  spaceXL,
  spaceXXL,
  scale100,
  xdlColorCardInspire01,
  xdlColorCardInspire02,
  xdlColorCardInspire03,
  xdlColorCardInspireText01,
  xdlColorCardInspireText02,
  xdlColorCardInspireText03,
  xdlColorTextOnDark,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const StyledHeadline = styled(Headline)`
  display: flex;
  align-items: center;
  margin-bottom: ${spaceXL};
  gap: ${spaceL};

  @media ${mediaConfined} {
    gap: ${spaceXXL};
  }
`;

export const StyledIllustration = styled(IllustrationExtMeditation)`
  flex-shrink: 0;

  @media ${mediaConfined} {
    width: 122px;
    height: 122px;
  }
`;

export const StyledOption = styled.button`
  border: 0 none;
  padding: ${spaceXL};
  border-radius: 16px;
  font-size: 1rem;
  cursor: pointer;
  margin-top: ${scale100};
  text-align: left;
  transition:
    background-color 0.2s linear,
    color 0.2s linear;
  width: 100%;

  &:nth-of-type(1) {
    background-color: ${xdlColorCardInspire01};
    margin-top: 0;

    &:hover,
    &:active {
      background-color: ${xdlColorCardInspireText01};
      color: ${xdlColorTextOnDark};
    }
  }

  &:nth-of-type(2) {
    background-color: ${xdlColorCardInspire02};

    &:hover,
    &:active {
      background-color: ${xdlColorCardInspireText02};
      color: ${xdlColorTextOnDark};
    }
  }

  &:nth-of-type(3) {
    background-color: ${xdlColorCardInspire03};

    &:hover,
    &:active {
      background-color: ${xdlColorCardInspireText03};
      color: ${xdlColorTextOnDark};
    }
  }
`;
